import { StrictMode, Suspense } from 'react';
import i18next from 'i18next';
import { createRoot } from 'react-dom/client';
import { initReactI18next } from 'react-i18next';
import './index.css';
import Root from './root';

i18next.use(initReactI18next).init({
  fallbackLng: 'en',
  defaultNS: 'base',
  keySeparator: '>>',
  nsSeparator: '::',
  interpolation: { escapeValue: false },
});

function renderApp() {
  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Root element not found');
  const root = createRoot(rootEl);
  root.render(
    <StrictMode>
      <Suspense fallback='loading'>
        <Root />
      </Suspense>
    </StrictMode>
  );
}

/**
 * Local dev only: `VITE_GK_MOCKS=happy-path` swaps the backend for msw mock profiles (see src/dev-mocks).
 * `import.meta.env.DEV` is statically false in production builds, so it's impossible to run the mocks there.
 */
if (import.meta.env.DEV && import.meta.env.VITE_GK_MOCKS) {
  const { startMocks } = await import('./dev-mocks/browser');
  // false when the mocks rendered one of their own pages (flow complete, mock IdP) in place of the app
  if (await startMocks(import.meta.env.VITE_GK_MOCKS)) {
    renderApp();
  }
} else {
  renderApp();
}
